// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__de8Tg","updateUser":"styles_updateUser__ClQ7O"};